// export const ASSET_PATH = "/wp-content/plugins/wishlist-react-app/react/build";
export const ASSET_PATH = window.prhReact.pluginLocation;


// WEBPACK FOOTER //
// ./src/utilities.js